export default __webpack_public_path__ + "static/media/bluetooth-disabled.c462272f.svg";